import { PartnerBusinessHours } from '@provision/entity-types';
import { HolidayWindow, TimeWindow } from '@provision/sidekick-utils';
import { Dayjs } from 'dayjs';
import { DATE_TIME_FORMAT } from 'src/constants/date';
import { PartnerHolidayEntity } from 'src/graphql/entities/partner-holiday/partner-holiday.types';
import { parsePartnerDateTime } from 'src/utils/partner-datetime';

export function toPartnerTimeWindows(
  partnerBusinessHours: Partial<PartnerBusinessHours>[],
): TimeWindow[] {
  return partnerBusinessHours.map((window) => ({
    weekDay: window.weekDay ?? 0,
    timeFrom: window.timeFrom ?? '',
    timeTo: window.timeTo ?? '',
  }));
}

export function toPartnerHolidayWindows(
  partnerHolidays: PartnerHolidayEntity[],
  timezone?: string,
): HolidayWindow[] {
  return partnerHolidays.map((holiday) => ({
    holidayStart: toPartnerInstant(holiday.holidayStart, timezone),
    holidayEnd: toPartnerInstant(holiday.holidayEnd, timezone),
    holidayName: holiday.holidayName,
  }));
}

/**
 * Holiday columns are `timestamp without time zone` and reach the client parsed viewer-local,
 * so they must be re-anchored to the partner's clock before they can be compared as instants.
 */
export function toPartnerInstant(value: Dayjs, timezone?: string): string {
  return timezone
    ? parsePartnerDateTime(value.format(DATE_TIME_FORMAT), timezone).toISOString()
    : value.toISOString();
}
